import "jspdf-autotable";
import "primeicons/primeicons.css";
import { Calendar } from "primereact/calendar";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import { useEffect, useState } from "react";
import Modal from "react-modal";
import { Link } from "react-router-dom";
import EventWiseUsersExcelReport from "../../component/DownloadButton/EventWiseUsersExcelReport";
import PdfEventWiseUsersReport from "../../component/DownloadButton/PdfEventWiseUsersReport";
import IconCalendarRegistration from "../../component/SvgIcons/IconCalendarRegistration";
import IconSearch from "../../component/SvgIcons/IconSearch";
import api from "../../Services/api";
import '../EventRegistration/index.css';
import CustomerTable from "./CustomerTable";
import IconArrowLeft from "../../component/SvgIcons/IconArrowLeft";
import { formatCountryDate } from "../../Services/countryTime";
Modal.setAppElement("#root");

export default function EventWiseUserRegistration() {
  const [searchQuery, setSearchQuery] = useState("");
  const [customerData, setCustomerData] = useState([]);
  const [pastEvent, setPastEvent] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [dates, setDates] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedFilter, setSelectedFilter] = useState(null); 
 const itemsPerPage = 10;

  useEffect(() => {
    // Fetch data from the API when the component mounts
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await api.post("/GetEventCustomers");          
        // console.log("API Response:", response.data.data);
         setPastEvent(response.data.data);     
        // Sort data in descending order by default (latest event first)
        const today = new Date();
        today.setHours(0, 0, 0, 0); // reset to start of today

          // Keep only upcoming events
          const upcomingEvents = response.data.data.filter(
            (event) => new Date(event.event_date) >= today
          );
          // Sort by date (latest upcoming first or soonest first – your choice)
          const sortedData = upcomingEvents.sort(
            //(a, b) => new Date(a.event_date) - new Date(b.event_date) // soonest first
             (a, b) => new Date(b.event_date) - new Date(a.event_date)
          );

        setCustomerData(sortedData);
      } catch (error) {
        console.error("Error fetching events:", error);
      }finally {
      setLoading(false); // stop loading
    }
    };

    fetchData();
  }, []); // Empty dependency array means this effect runs once when the component mounts

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1); // Reset to the first page on search
  };


  const filteredEventData = customerData.filter((customer) => {
    const searchLower = searchQuery.toLowerCase().trim();
    const formattedSearchDate = normalizeDateFormat(searchQuery);

    const eventDate = new Date(customer.event_date);
    eventDate.setHours(0, 0, 0, 0); // Remove time for accurate comparison

    const startDate = dates?.[0] ? new Date(dates[0]) : null;
    const endDate = dates?.[1] ? new Date(dates[1]) : null;

    if (startDate && endDate) {
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999); // Ensure the entire end date is included
    }

    const isWithinDateRange =
      startDate && endDate ? eventDate >= startDate && eventDate <= endDate : true; // Show all if no date selected

    return (
      isWithinDateRange && (
        customer.name?.toLowerCase().includes(searchLower) ||
        customer.email?.toLowerCase().includes(searchLower) ||
        customer.organization?.toLowerCase().includes(searchLower) ||
        customer.confirmation?.toLowerCase().includes(searchLower) ||
        customer.mobile?.includes(searchQuery) ||
        customer.tallynumber?.includes(searchQuery) ||
        customer.NoOfParticipants?.includes(searchQuery) ||
        normalizeDateFormat(customer.registration_date) === formattedSearchDate ||
        normalizeDateFormat(customer.event_date) === formattedSearchDate ||
        customer.Title?.toLowerCase().includes(searchLower) ||
        customer.ModeOfMeeting?.toLowerCase().includes(searchLower)
    )   
    );
  });

  // Function to normalize date formats (converts everything to "DD-MM-YYYY")
  function normalizeDateFormat(date) {
    if (!date) return "";

    // If date is already in "D-MM-YYYY" or "DD-MM-YYYY" format, normalize it
    if (/^\d{1,2}-\d{2}-\d{4}$/.test(date)) {
      const [day, month, year] = date.split("-");
      return `${day.padStart(2, "0")}-${month}-${year}`; // Ensures "DD-MM-YYYY" format
    }

    const parsedDate = new Date(date);
    if (isNaN(parsedDate)) return ""; // Return empty if invalid date

    // Extract day, month, and year
    return formatCountryDate(parsedDate).replace(/\//g, "-"); // Format as "DD-MM-YYYY"
  }
 

 // Convert event_date into JS Date objects from API data
const dateTemplate = (dateMeta) => {
  const { day, month, year } = dateMeta;
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  // Find the matching event for this date
  const matchingEvent = pastEvent.find((event) => {
    const d = new Date(event.event_date);
    d.setHours(0, 0, 0, 0);
    return d.getDate() === day && d.getMonth() === month && d.getFullYear() === year;
  });

  // Determine class based on past/future
  let className = "";
  if (matchingEvent) {
    const eventDate = new Date(matchingEvent.event_date);
    eventDate.setHours(0, 0, 0, 0);

    if (eventDate < today) {
      className = "btn-danger past-event-date"; // past = red
    } else if (eventDate > today) {
      className = "btn-success future-event-date"; // future = green
    } else {
      className = "btn-primary today-event-date"; // today = purple or any style
    }
  }

  return (
    <span className={className}>
      {day}
    </span>
  );
};

const formatDate = (dateString) => {
  const date = new Date(dateString);
  return formatCountryDate(date).replace(/\//g, "-"); // 22-01-2025
};

const uniqueDates = [
  ...new Set(filteredEventData.map((item) => formatDate(item.event_date))),
];

const participantsByDate = uniqueDates.map((date) => {
  const total = filteredEventData
    .filter((item) => formatDate(item.event_date) === date)
    .reduce((sum, item) => sum + Number(item.NoOfParticipants || 0), 0);
  return { date, total };
});

// ⬇️ Add this here
// 🔹 Pivot data: group by Name, then by Date
const pivotData = {};

filteredEventData.forEach((item) => {
  const date = formatDate(item.event_date);
  const name = item.confirmation;

  if (!pivotData[name]) {
    pivotData[name] = { confirmation: name };
  }

  if (!pivotData[name][date]) {
    pivotData[name][date] = 0;
  }

  pivotData[name][date] += Number(item.NoOfParticipants || 0);
});

const groupedData = Object.values(pivotData);
// First, compute filteredDetails
const filteredDetails = selectedFilter
  ? filteredEventData.filter(
      (item) =>
        item.confirmation === selectedFilter.name &&
        formatDate(item.event_date) === selectedFilter.date
    )
  : [];

// Then calculate pagination for filteredDetails
const indexOfLastFilteredItem = currentPage * itemsPerPage;
const indexOfFirstFilteredItem = indexOfLastFilteredItem - itemsPerPage;
const currentFilteredItems = filteredDetails.slice(
  indexOfFirstFilteredItem,
  indexOfLastFilteredItem
);

// Total pages for filteredDetails
const totalFilteredPages = Math.ceil(filteredDetails.length / itemsPerPage);

// Handle page change for filteredDetails
const handleFilteredPageChange = (page) => {
  if (page > 0 && page <= totalFilteredPages) {
    setCurrentPage(page);
  }
};


  return (
    <section className="eventpage">
    <div className="d-flex justify-content-center  headercustomerpage">
      Individual Registration Statistics 
    </div>

      {/* <div className="pageLeftspace"> */}
      <div className="eventregistration">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center topsearchbar gap-3">
          <div className="d-flex gap-2 w-100 calenderleft">    
            <Link
              to="/event-registration"
              type="button"
              className="btn btn-purpal addbutton"
            >
              <IconArrowLeft/>
              Back
            </Link>
                  
            <Calendar
              value={dates}           
            onChange={(e) => {
                setDates(e.value);

                if (e.value && Array.isArray(e.value)) {
                const [startDate, endDate] = e.value;

                if (startDate && endDate) {
                    // 📌 Range selected
                    const sDate = new Date(startDate);
                      const eDate = new Date(endDate);
                      sDate.setHours(0,0,0,0);
                      eDate.setHours(23,59,59,999);
                      const filtered = pastEvent.filter((event) => {
                          const eventDate = new Date(event.event_date);
                          eventDate.setHours(0,0,0,0);
                          return eventDate >= sDate && eventDate <= eDate;
                      });
                      setCustomerData(filtered);
                } else if (startDate && !endDate) {
                    // 📌 Only one date selected → filter for exact date
                    const targetDate = new Date(startDate);
                    targetDate.setHours(0, 0, 0, 0);

                    const filtered = pastEvent.filter((event) => {
                    const eventDate = new Date(event.event_date);
                    eventDate.setHours(0, 0, 0, 0);
                    return eventDate.getTime() === targetDate.getTime();
                    });

                    setCustomerData(filtered);
                } else {
                    // 📌 Reset (no dates)
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);
                    const upcomingEvents = pastEvent.filter(
                    (event) => new Date(event.event_date) >= today
                    );
                    setCustomerData(upcomingEvents);
                }

                setCurrentPage(1);
                }
            }}
              selectionMode="range"
              readOnlyInput
              className="Calendar"
              panelClassName="custom-calendar-panel" 
              placeholder="Select Date Range"
              dateFormat="dd-mm-yy"
              showIcon
              icon={<IconCalendarRegistration />}
              dateTemplate={dateTemplate}
            />
            {/* <Link to="#" className="d-flex align-items-center" onClick={() => handleSort("event_date")}>
              <IconUpdownFilter />
            </Link> */}
          </div>

        <div className="d-flex flex-column flex-md-row gap-2 w-100 justify-content-end">     
          <div className="input-container">
            <input
              type="text"
              id="name"
              value={searchQuery}
              onChange={handleSearchChange}
              placeholder="Search Here.."
            />

            {/* <label htmlFor="name">Search</label> */}
            <span className="underline"></span>
            <div className="search-icon">
              <IconSearch />
            </div>
          </div>

            <div className="d-flex gap-2 justify-content-center">
           <EventWiseUsersExcelReport 
            data={selectedFilter ? filteredDetails : []} 
            disabled={!selectedFilter}
          />
          <PdfEventWiseUsersReport 
            data={selectedFilter ? filteredDetails : []} 
            disabled={!selectedFilter}
          />
          </div>  

           </div>

        </div>

        <div className="d-flex flex-wrap gap-2">
        <div className="tableheader event-detailstable w-100" style={{minHeight: "initial"}}>
          <h4 className="text-dark text-center mb-3">Registration & Participation Statistics Report</h4>

          <table className="table">
        <thead>
          <tr>
            <th className="text-center" width="10px">Sr. No.</th>
            <th>Date</th>
            {groupedData.map((customer) => (
              <th className="text-center" key={customer.confirmation}>
                {customer.confirmation} {/* Show customer name here */}
              </th>
            ))}
            <th>
           Total Part.
          </th>
          </tr>
        </thead>
  <tbody>
  {loading ? (
  <tr>
    <td colSpan={groupedData.length + 3} align="center">
      Loading...
    </td>
  </tr>
) : participantsByDate.length > 0 ? (
  <>
    {participantsByDate.map((d, idx) => {
      // total participants for this date (all confirmations combined)
      const totalForDate = filteredEventData
        .filter((item) => formatDate(item.event_date) === d.date)
        .reduce((sum, item) => sum + Number(item.NoOfParticipants || 0), 0);

      return (
        <tr key={d.date}>
          {/* Row index */}
          <td align="center">{idx + 1}</td>

          {/* Date */}
          <td>
            <strong>{d.date}</strong>
          </td>

          {/* Confirmation columns */}
          {groupedData.map((customer) => {
            const registrationCount = filteredEventData.filter(
              (item) =>
                item.confirmation === customer.confirmation &&
                formatDate(item.event_date) === d.date
            ).length;

            const participantCount = filteredEventData
              .filter(
                (item) =>
                  item.confirmation === customer.confirmation &&
                  formatDate(item.event_date) === d.date
              )
              .reduce((sum, item) => sum + Number(item.NoOfParticipants || 0), 0);

            const isActive =
              selectedFilter?.name === customer.confirmation &&
              selectedFilter?.date === d.date;

            return (
              <td key={customer.confirmation} align="center">
                {registrationCount > 0 ? (
                  <button
                    type="button"
                    className={`witoutpadding border-0 ${
                      isActive ? "active-button" : ""
                    }`}
                    onClick={() => {
                      if (isActive) {
                        setSelectedFilter(null);
                        setCurrentPage(1);
                      } else {
                        setSelectedFilter({
                          name: customer.confirmation,
                          date: d.date,
                        });
                        setCurrentPage(1);
                      }
                    }}
                  >
                    {registrationCount} / {participantCount}
                  </button>
                ) : (
                  <span>0 / 0</span>
                )}
              </td>
            );
          })}

          {/* 🔹 Date-wise total participants column */}
          <td align="center">
            <strong>{totalForDate}</strong>
          </td>
        </tr>
      );
    })}

   {/* <tr className="bg-light">
        <td colSpan={2} align="left">
          <strong>Grand Total</strong>
        </td>
        {groupedData.map((customer) => {
          const grandTotal = filteredEventData
            .filter((item) => item.confirmation === customer.confirmation)
            .reduce((sum, item) => sum + Number(item.NoOfParticipants || 0), 0);

          return (
            <td key={`total-${customer.confirmation}`} align="center">
              <strong>{grandTotal}</strong>
            </td>
          );
        })}
      </tr> */}
      
    {/* 🔹 Grand total row */}
    {/* <tr className="bg-light">
      <td colSpan={3} align="left">
        <strong>Grand Total</strong>
      </td>
      <td colSpan={groupedData.length} align="center">
        <strong>
          {filteredEventData.reduce(
            (sum, item) => sum + Number(item.NoOfParticipants || 0),
            0
          )}
        </strong>
      </td>
    </tr> */}
  </>
) : (
  <tr>
    <td colSpan={groupedData.length + 3} align="center">
      No data found
    </td>
  </tr>
)}

</tbody>


        </table>

          </div>

           {selectedFilter && filteredDetails.length > 0 && (
            <CustomerTable
              loading={loading}
              currentItems={currentFilteredItems} // Only 10 items per page
              indexOfFirstItem={indexOfFirstFilteredItem}
              participantsByDate={participantsByDate}
              currentPage={currentPage}
              totalPages={totalFilteredPages}
              itemsPerPage={itemsPerPage}
              filteredEventData={filteredDetails}
              handlePageChange={handleFilteredPageChange}
            />
          )}
        
        </div>
      </div>
    </section>
  );
}
